import styled from 'styled-components';
import { SaveYourProjectAndContinueStyled } from '../SaveYourProjectAndContinueStyled';
export const SaveYourProjectAndContinueStyledOV = styled(SaveYourProjectAndContinueStyled)``;
